function About() {
  return (
    <section className="intro" id="about">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Who we are</div>
          <h2>
            <span className="intro-title-line">Two markets.</span>
            <span className="intro-title-line">One shared standard.</span>
          </h2>
          <p>WillMars Re operates through its presence in Kenya and Tanzania, with each market supported by relevant local understanding and leadership. Together, the teams connect African insurers and complex risks with regional and international reinsurance capacity.</p>
        </div>
      </div>
    </section>
  )
}

export default About
